export default __webpack_public_path__ + "static/media/chil.ff9d66d6.PNG";